import { useEffect, useState } from 'react'
import { useSelector,useDispatch } from 'react-redux'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { AppDispatch } from '../../store'

import { Box, Button, Tab, Tabs, Typography } from '@mui/material'

import colors from '../../constants/colors'
import CloseIcon from '@mui/icons-material/Close'
import reportsSelectors from '../../store/reports/reportsSelectors'
import changesSelector from '../../store/changes/changesSelector'
import constants from './constants'
import { triageLevelStates } from '../../store/reports/types'
import usersSelectors from '../../store/users/usersSelectors'
import authSelectors from '../../store/auth/authSelectors'
import { APP_MODE } from '../../sharedTypes'

import { deselectCase } from '../../store/reports/reportsSlice'

const getCurrentRoute = () => {
  return window.location.pathname
}
const CaseNavbar: React.FC = () => {
  const [value, setValue] = useState(getCurrentRoute() ?? 0)
  const selectedReport = useSelector(reportsSelectors.selectedReport)
  const numberOfChanges = useSelector(changesSelector.numberOfChanges)
  const teamMembers = useSelector(usersSelectors.teamMembers)
  const appMode = useSelector(authSelectors.userOrganizationType)
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch<AppDispatch>()
  const navItems = (() => {
    if (appMode === APP_MODE.light) return []
    if (selectedReport?.report_status.status === 'OPEN') {
      return constants.navItems.slice(0, constants.navItems.length - 1)
    }
    return constants.navItems
  })()

  useEffect(() => {
    setValue(getCurrentRoute())
  }, [window.location.pathname])

  const exitCaseHandler = () => {
    dispatch(deselectCase({ value: undefined }))
    navigate('/inbox')
    if (numberOfChanges) {
      return
    }
  }

  const handleChange = (event: React.SyntheticEvent, newValue: any) => {
    //event.preventDefault()
    if (numberOfChanges) {
      return
    }
    setValue(newValue)
  }

  // const resolveNavbarContent = () => {
  //   if (
  //     selectedReport?.triage_level &&
  //     selectedReport?.triage_level !== triageLevelStates.TRANSFERED_FOR_ASSIGNMENT
  //   ) {
  //     // if (
  //     //   selectedReport?.triage_level === triageLevelStates.IMMEDIATE_ATTENTION_REQUIRED &&
  //     //   teamMembers?.length == 0
  //     // ) {
  //     //   return <></>
  //     // }
  //     return (
  //       <Tabs value={value} onChange={handleChange} sx={constants.tabsStyle}>
  //         {navItems.map(({ href, title }, index) => (
  //           <Tab
  //             component={Link}
  //             value={href}
  //             label={title}
  //             to={href}
  //             key={`${index}${href}`}
  //             sx={{ typography: 'bodyRegular' }}
  //           />
  //         ))}
  //       </Tabs>
  //     )
  //   }

  //   if (location.pathname.includes('/newCase')) {
  //     return (
  //       <Typography variant='boldTextXlarge' color={colors.TAG_BLUE}>
  //         New Case
  //       </Typography>
  //     )
  //   }
  // }

  const resolveNavbarContent = () => {
    if (
      selectedReport?.triage_level &&
      selectedReport?.triage_level !== triageLevelStates.TRANSFERED_FOR_ASSIGNMENT
    ) {
      const currentPath = location.pathname;
      const validTabValue =
        navItems.find(item => currentPath.startsWith(item.href))?.href || false;

      return (
        <Tabs
          value={validTabValue}
          onChange={(e, newValue) => {
            if (!numberOfChanges) {
              setValue(newValue);
              navigate(newValue);
            }
          }}
          sx={constants.tabsStyle}
        >
          {navItems.map(({ href, title }, index) => (
            <Tab
              component={Link}
              value={href}
              label={title}
              to={href}
              key={`${index}${href}`}
              sx={{ typography: 'bodyRegular' }}
            />
          ))}
        </Tabs>
      );
    }

    if (location.pathname.includes('/newCase')) {
      return (
        <Typography variant="boldTextXlarge" color={colors.TAG_BLUE}>
          New Case
        </Typography>
      );
    }
  };


  return (
    <Box className={'t-viewport-subheader'}>
      <Box sx={constants.tabsContainerStyle}>{resolveNavbarContent()}</Box>
      <Button
        startIcon={<CloseIcon />}
        sx={{ color: colors.BLACK, px: '2rem' }}
        onClick={exitCaseHandler}
      >
        Exit Case
      </Button>
    </Box>
  )
}

export default CaseNavbar
